<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    @if (strategyGroup()) {
      @let brandStrategiesLength = strategyGroup()!.brandStrategies.length;
      <div class="flex flex-col gap-2" [ngClass]="{ 'flex-1': brandStrategiesLength > 0 }">
        <div class="flex items-center justify-between">
          <div class="font-medium text-gray-600">
            {{ t("sp-strategy-group-page.brand_defense_strategies") }}
            <IBadge class="ml-1 align-bottom" [label]="strategyGroup()!.brandStrategies.length + ''" color="gray" />
          </div>

          <IButton
            [label]="t('sp-strategy-group-page.add_a_new_brand_defense_strategy')"
            size="sm"
            color="white"
            icon="icon-[material-symbols--add-rounded]"
            [disabled]="isReadOnly()"
            (onClick)="openSubStrategyCreationPage(StrategyType.BRAND)"
          />
        </div>

        @if (brandStrategiesLength > 0) {
          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="brandStrategyGridOptions"
              [rowData]="strategyGroup()!.brandStrategies"
              [rowDragManaged]="true"
              #brandStrategies
            />
          </div>
        }
      </div>

      @let keywordStrategiesLength = strategyGroup()!.keywordStrategies.length;
      <div class="flex flex-col gap-2" [ngClass]="{ 'flex-1': keywordStrategiesLength > 0 }">
        <div class="flex items-center justify-between">
          <div class="font-medium text-gray-600">
            {{ t("sp-strategy-group-page.focus_strategies") }}
            <IBadge class="ml-1 align-bottom" [label]="keywordStrategiesLength + ''" color="gray" />
          </div>

          <IButton
            [label]="t('sp-strategy-group-page.add_a_new_focus_strategy')"
            size="sm"
            color="white"
            icon="icon-[material-symbols--add-rounded]"
            [disabled]="isReadOnly()"
            (onClick)="openSubStrategyCreationPage(StrategyType.KEYWORD)"
          />
        </div>

        @if (keywordStrategiesLength > 0) {
          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="keywordStrategyGridOptions"
              [rowData]="strategyGroup()!.keywordStrategies"
              [rowDragManaged]="true"
              #keywordStrategies
            />
          </div>
        }
      </div>

      @if (strategyGroup()!.productStrategies.length > 0) {
        <div class="flex flex-1 flex-col gap-2">
          <div class="flex items-center justify-between">
            <div class="font-medium text-gray-600">
              {{ t("sp-strategy-group-page.main_strategies") }}
              <IBadge class="ml-1 align-bottom" [label]="strategyGroup()!.productStrategies.length + ''" color="gray" />
            </div>
            <IButton
              [label]="t('sp-strategy-group-page.add_a_new_main_strategy')"
              size="sm"
              color="white"
              icon="icon-[material-symbols--add-rounded]"
              [disabled]="isReadOnly()"
              (onClick)="openSubStrategyCreationPage(StrategyType.PRODUCT)"
            />
          </div>

          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="productStrategyGridOptions"
              [rowData]="strategyGroup()!.productStrategies"
              #productStrategies
            />
          </div>
        </div>
      }
      @if (strategyGroup()!.blacklist && strategyGroup()!.blacklist!.length > 0) {
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <div class="font-medium text-gray-600">
              {{ t("common.blacklist") }}
              <IBadge class="ml-1 align-bottom" [label]="strategyGroup()!.blacklist!.length + ''" color="gray" />
            </div>

            <IButton
              size="sm"
              color="gray"
              variant="ghost"
              [icon]="isBlacklistOpen() ? 'icon-[lucide--chevron-down]' : 'icon-[lucide--chevron-right]'"
              (onClick)="isBlacklistOpen.set(!isBlacklistOpen())"
            />
          </div>
        </div>
        <IAccordion [isOpen]="isBlacklistOpen()">
          @if (strategyGroup()!.blacklist!.length >= MAX_BLACKLIST_ITEMS) {
            <div class="mb-2 p-px">
              <IAlert
                type="warning"
                [title]="t('sp-strategy-group-page.you_have_reached_the_max_number_of_blacklist_items')"
              />
            </div>
          }
          <IButton
            class="mb-2"
            size="sm"
            label="{{ t('common.edit') }}"
            color="white"
            icon="icon-[material-symbols--edit-square-outline]"
            [disabled]="isReadOnly()"
            (onClick)="openBlackListEditionModal()"
          />
          <app-blacklist-view [blacklist]="strategyGroup()!.blacklist ?? []"></app-blacklist-view>
        </IAccordion>
      }
    }
  </div>
</ng-container>
